module.exports = __webpack_public_path__ + "img/aquarell_1920_1080_mit_wasserzeichen_26.d7712e81.jpg";